import React, { Component } from 'react';
import { Box, List, ListItem, ListItemText, Typography } from '@mui/material';
import { Routes, Route, Link } from 'react-router-dom';
import Template from './TemplateComponent';
import UserSearch from '../users/UserSearch';
import UserProfilePage from '../users/UserProfilePage';
import Misc from '../misc/Misc';
import HomeBanner from '../misc/HomeBanner/HomeBanner';

export const ROUTES = [
  { path: '/users', title: 'Users', element: <UserSearch />, includeInMenu: true },
  { path: '/users/:uid', title: 'User Profile', element: <UserProfilePage />, includeInMenu: false },
  { path: '/home-banner', title: 'Home Banner', element: <HomeBanner />, includeInMenu: true },
  { path: '/misc', title: 'Miscellaneous', element: <Misc />, includeInMenu: true },
]

const drawerWidth = 240;

class AdminPageComponent extends Component {
  render() {
    return (
      <Box sx={{ display: 'flex' }}>
        <Box
          sx={{
            width: drawerWidth,
            flexShrink: 0,
            [`& .MuiDrawer-paper`]: { width: drawerWidth, boxSizing: 'border-box' },
            borderRight: '1px solid #e0e0e0',
            height: '100vh',
          }}
        >
          <Typography variant="h6" noWrap component="div" sx={{ p: 2 }}>
            Admin Dashboard
          </Typography>
          <List>
            {ROUTES.filter(route => route.includeInMenu).map(({ title, path }) => (
              <ListItem button key={title} component={Link} to={path} sx={{ borderBottom: '1px solid #e0e0e0', pt: '1rem', pb: '1rem' }}>
                <ListItemText primary={title} />
              </ListItem>
            ))}
          </List>
        </Box>
        <Box
          component="main"
          sx={{ flexGrow: 1, bgcolor: 'background.default', p: 3 }}
        >
          <Routes>
            {ROUTES.map(({ path, element }) => (
              <Route key={path} path={path} element={element} />
            ))}
          </Routes>
        </Box>
      </Box>
    );
  }
}

export default AdminPageComponent;
